export default {"src":"/_next/static/image/public/assets/icons/insert-emoticon.7a4cda973cdd02f174f31741f2e998bf.svg","height":24,"width":24};